import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog errors that are outside our control
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('postMessage') || 
      args[0]?.includes?.('PerformanceServerTiming') ||
      args[0]?.includes?.('posthog')) {
    return;
  }
  originalError.apply(console, args);
};

// Catch unhandled errors from third-party scripts
window.addEventListener('error', (event) => {
  if (event.filename?.includes('posthog') || 
      event.message?.includes('PerformanceServerTiming')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
